module.exports = __webpack_public_path__ + "img/storyboard-lite.ea81dce0.png";